/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CustomerNotificationEvent {
  DELIVERY_SCHEDULED="DELIVERY_SCHEDULED",
ON_THE_WAY="ON_THE_WAY",
SUCCESSFUL_DELIVERY="SUCCESSFUL_DELIVERY",
MISSED_DELIVERY="MISSED_DELIVERY"
}

/**
* CustomerNotificationEvent
*/
export const CustomerNotificationEventEnumType = types.enumeration("CustomerNotificationEvent", [
        "DELIVERY_SCHEDULED",
  "ON_THE_WAY",
  "SUCCESSFUL_DELIVERY",
  "MISSED_DELIVERY",
      ])
